export default {
  getRankingList: state => {
    return state.rankingList;
  },

  isEmpty: state => {
    return !state.rankingList.length;
  },

  isLoading: state => {
    return state.isLoading;
  },

  getTotalItems: state => {
    return state.totalItems;
  }
};
